<form (click)="debugForm(constructor.name)" (keydown)="(null)">
  <mat-form-field class="w-[calc(100%-64px)]">
    <mat-label class="text-xl font-semibold">Fuseau horaire</mat-label>
    <mat-select [formField]="formTree.timezone">
      @for (tz of timezones; track tz.id) {
        <mat-option [value]="tz.id">{{ tz.label }}</mat-option>
      }
    </mat-select>
    <mat-error>Fuseau horaire invalide</mat-error>
  </mat-form-field>
</form>
